<template>
  <div class="flex flex-col gap-1">
    <label class="font-semibold" :for="name">{{ label }}</label>
    <input
      v-model="inputValue"
      class="rounded border px-5 py-3"
      :name="name"
      :id="name"
      :placeholder="placeholder"
      @input="debouncedOnChange"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import _debounce from 'lodash.debounce';
import { useFilterStore } from '@/store/filterStore.js';

const props = defineProps({
  name: { type: String, required: true },
  label: { type: String, required: true },
  placeholder: { type: String, default: '' },
  property: { type: Number, required: true },
  dataType: { type: Number, required: true },
});

const inputValue = ref('');
const filterStore = useFilterStore();

const emitValue = () => {
  filterStore.updateFilter({
    type: 'text',
    property: props.property,
    value: inputValue.value,
  });
  filterStore.fetchDynamicCount();
};

const debouncedOnChange = _debounce(emitValue, 500);
</script>

<style scoped>
/* optional custom styles */
</style>
